// Clients will provide vimeo link.
// If vimeo link is https://vimeo.com/557230853/dcf7836b65
// then the vimeoId is 557230853, not the dcf..

import arthroplastySubspecialty from '../../images/gallerium/onDemand/subspecialty/arthroplasty.png'
import paediatricsSubspecialty from '../../images/gallerium/onDemand/subspecialty/paediatrics.png'
import footandankleSubspecialty from '../../images/gallerium/onDemand/subspecialty/footandankle.png'

import amgenVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/amgen.png'
import medartisVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/medartis.png'
import menariniVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/menarini.png'
import pfizerVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/pfizer.png'
import strykerVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/stryker.png'
import zimmerbiometVirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/zimmerbiomet.png'
import gsk2VirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/gsk2.png'
import jnj2VirtualProductTheatre from '../../images/gallerium/onDemand/virtualProductTheatre/jnj2.png'

import amgenVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/amgen.png'
import medartisVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/medartis.png'
import medartis2VirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/medartis2.png'
import pfizerVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/pfizer.png'
import smithNephewVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/smith-nephew.png'
import smithNephew2VirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/smith-nephew2.png'
import gskVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/gsk.png'
import jnjVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/jnj.png'
import novartisVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/novartis.png'
import menarini2VirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/menarini2.png'
import strykerVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/stryker.png'
import zimmerbiometVirtualSatelliteSymposium from '../../images/gallerium/onDemand/virtualSatelliteSymposiums/zimmerbiomet.png'

export interface onDemandVideosType {
  vimeoId: string
  title: string
  thumbnail?: string
  /**
   * can be react routes, ie. /booths/1, /lobby
   * or external link, ie. https://something.com, mailto:hello@email.com
   */
  buttonUrl?: string
  buttonText?: string
}

const planeriesVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '1',
    title: 'Video Title 1',
  },
  {
    vimeoId: '2',
    title: 'Video Title 2',
  },
  {
    vimeoId: '88',
    title: 'Video Title 3',
  },
]

const subspecialtyVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '566861216',
    title: 'Patellar Resurfacing Surgical Technique By Dr Samuel J MacDessi',
    thumbnail: arthroplastySubspecialty,
  },
  {
    vimeoId: '567327065',
    title: 'Role of Off Loading in Managing Diabetic Foot Ulcer By Adj. Assoc Prof Dr Chua Yeok Pin',
    thumbnail: footandankleSubspecialty,
  },
  {
    vimeoId: '567286404',
    title: 'Chronic Osteomyelitis: Is Single Stage Treatment Possible? By Asst. Prof Dr Aryadi Kurniawan',
    thumbnail: paediatricsSubspecialty,
  },
]
const awardsVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '5',
    title: 'Video Title 1',
  },
  {
    vimeoId: '6',
    title: 'Video Title 2',
  },
]

const masterclassVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '11',
    title: 'Video Title 1',
  },
  {
    vimeoId: '12',
    title: 'Video Title 2',
  },
]

const lunchBreakfastSymposiumVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '13',
    title: 'Video Title 1',
  },
  {
    vimeoId: '14',
    title: 'Video Title 2',
  },
]

const virtualSatelliteSymposiumsVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '564553440',
    title: 'All around the Menicus: Meniscal Expert Forum',
    thumbnail: smithNephewVirtualSatelliteSymposium,
    buttonUrl: '/booths/37',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '566006764',
    title: 'Knee Arthroplasty Web Series On Asian Knees',
    thumbnail: smithNephew2VirtualSatelliteSymposium,
    buttonUrl: '/booths/37',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '566939698',
    title: 'The Art and Science of Acute Pain Management',
    thumbnail: menarini2VirtualSatelliteSymposium,
    buttonUrl:'/booths/36',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564518784',
    title: "Tailoring Osteoporosis Therapy to the Patient's Risk Profile By S.Ferarri",
    thumbnail: amgenVirtualSatelliteSymposium,
    buttonUrl: '/booths/30',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564547768',
    title: 'Pain Management After Joint Replacement Surgery By Dr G Ruslan Nazaruddin Simanjuntak',
    thumbnail: pfizerVirtualSatelliteSymposium,
    buttonUrl: '/booths/29',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564558597',
    title: 'Mako Partial Knee and Total Knee By Dr Hitt and Dr Sastry',
    thumbnail: strykerVirtualSatelliteSymposium,
    buttonUrl: '/booths/34',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564561342',
    title: 'Technologies In Total Knee Arthroplasty By Prof Dr Nor Hamdan, Dr Suhail Suresh, Dato Dr Lee Keat Hwa',
    thumbnail: zimmerbiometVirtualSatelliteSymposium,
    buttonUrl: '/booths/32',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564527171',
    title: 'A New Clavicle Plate: Development & First Clinical Experience By Prof Dr Rainer Meffert',
    thumbnail: medartisVirtualSatelliteSymposium,
    buttonUrl: '/booths/33',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '564531512',
    title: 'Management of Complex Distal Radius Fractures By Dr Scott G. Edwards',
    thumbnail: medartis2VirtualSatelliteSymposium,
    buttonUrl: '/booths/33',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '566136118',
    title: 'Innovative Solution for Neck of Femur Trimmed By Prof Stoffel',
    thumbnail: jnjVirtualSatelliteSymposium,
    buttonUrl: '/booths/31',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '566010456',
    title: 'Inflammatory Back Pain & Ankylosing Spondylitis: Updates for Orthopaedic Surgeons By Dr Amir Azlan Zain',
    thumbnail: novartisVirtualSatelliteSymposium,
    buttonUrl: 'mailto:irene.chen-1@novartis.com',
    buttonText: 'Submit Your Question',
  },
  {
    vimeoId: '566007871',
    title: 'The Role of Calcium And Vitamin D In The Treatment Of Osteoporosis By Dr Yeap Swan Sim',
    thumbnail: gskVirtualSatelliteSymposium,
    buttonUrl: '/booths/35',
    buttonText: 'Visit Booth',
  },
]

const virtualProductTheatreVideos: Array<onDemandVideosType> = [
  {
    vimeoId: '566485951',
    title: 'Skudexa Ketesse Virtual Product Theatre Video',
    thumbnail: menariniVirtualProductTheatre,
    buttonUrl:'/booths/36',
    buttonText: 'Vist Booth'
  },
  {
    vimeoId: '564563142',
    title: 'Management of Osteoporosis - An Expert Opinion By Prof Felicia Cosman',
    thumbnail: amgenVirtualProductTheatre,
    buttonUrl: '/booths/30',
    buttonText: 'Vist Booth',
  },
  {
    vimeoId: '564498828',
    title: 'Pfizer Virtual Product Theatre Video',
    thumbnail: pfizerVirtualProductTheatre,
    buttonUrl: '/booths/29',
    buttonText: 'Vist Booth',
  },
  {
    vimeoId: '564565196',
    title: 'Mako Total and Partial Knee By Dr Jim Nevelos',
    thumbnail: strykerVirtualProductTheatre,
    buttonUrl: '/booths/34',
    buttonText: 'Vist Booth',
  },
  {
    vimeoId: '564563980',
    title: 'Medartis Virtual Product Theatre Video',
    thumbnail: medartisVirtualProductTheatre,
    buttonUrl: '/booths/33',
    buttonText: 'Vist Booth',
  },
  {
    vimeoId: '564566080',
    title: 'Zimmer Biomet Virtual Product Theatre Video',
    thumbnail: zimmerbiometVirtualProductTheatre,
    buttonUrl: '/booths/32',
    buttonText: 'Vist Booth',
  },
  {
    vimeoId: '566482496',
    title: 'Caltrate Virtual Product Theatre Video',
    thumbnail: gsk2VirtualProductTheatre,
    buttonUrl: '/booths/35',
    buttonText: 'Visit Booth',
  },
  {
    vimeoId: '566847136',
    title: 'Total Femur - FNS, FRN, TFNA Virtual Prodict Video',
    thumbnail: jnj2VirtualProductTheatre,
    buttonUrl: '/booths/31',
    buttonText: 'Visit Booth',
  },
]

export {
  // planeriesVideos,
  subspecialtyVideos,
  // awardsVideos,
  // masterclassVideos,
  // lunchBreakfastSymposiumVideos,
  virtualSatelliteSymposiumsVideos,
  virtualProductTheatreVideos,
}
